<template>
  <div class="modal fade" id="edit-cards" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="cards-edit-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("cards.edit_card") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-sm-6">
              <label class="form-label">{{ $t("cards.username") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-at"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="card.username"
                  disabled
                />
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label">{{ $t("cards.username") }}</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-lock"></i></div>
                <input
                  type="text"
                  class="form-control"
                  v-model="card.password"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label">{{ $t("cards.expires_at") }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-calendar-time"></i>
                </div>
                <input
                  v-model="card.fixed_expiration"
                  type="datetime-local"
                  class="form-control"
                  placeholder="YYYY-MM-DD HH:MM"
                  :disabled="
                    this.user.type == 'reseller' ||
                      !hasPrivilege('cards_edit_expiration_cards')
                  "
                />
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label">{{
                $t("cards.allowed_sessions")
              }}</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <input
                  type="number"
                  id="devices"
                  class="form-control"
                  v-model="card.allowed_sessions"
                  placeholder="e.g. 2"
                  min="1"
                />
              </div>
            </div>
            <div class="text-danger">
              <div v-if="errors.username">{{ errors.username }}</div>
              <div v-if="errors.password">{{ errors.password }}</div>
              <div v-if="errors.profile_id">{{ errors.profile_id }}</div>
              <div v-if="errors.ip_address">{{ errors.ip_address }}</div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                :disabled="!validated"
                class="btn btn-success"
                @click.prevent="store"
              >
                {{ $t("control.submit") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { hasPrivilege } from "../../global_constants";
export default {
  name: "EditCards",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      error: "",
      message: "",
      card: {
        username: "",
        password: "",
        profile_id: "",
        allowed_sessions: 1,
        fixed_expiration: null,
        expires_at: "",
      },
      startTime: {
        hours: 0,
        minutes: 0,
      },
      loading: false,
      profiles: null,
      isError: false,
      error_message: "",
      errors: {
        username: null,
        password: null,
        profile_id: null,
        ip_address: null,
      },
      validated: false,
      date_format: (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();

        return `${day}-${month}-${year} ${hour}:${minute}`;
      },
      price: 0,
    };
  },
  props: {
    selectedCard: {
      type: Object,
      default: null,
    },
  },
  async created() {
    this.loading = true;
    await this.$nextTick();
    if (this.$route.query.card_id || this.selectedCard) {
      await this.fetchCard(this.$route.query.card_id || this.selectedCard.id);
      this.validated = true;
    }
    this.loading = false;
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.card.fixed_expiration = moment(this.card.fixed_expiration).format(
        "yyyy-MM-DD HH:mm",
      );
      if (this.card.id) {
        const response = await axios.put(
          `/cards/edit/${this.card.id}`,
          this.card,
        );
        if (response.status == 200) {
          this.$notify({
            text: this.$t("messages.card_updated_successfully"),
            type: "success",
          });
          document.getElementById("cards-edit-close").click();
          this.$emit("updated");
        }
      }
    },
    async fetchProfiles() {
      const response = await axios.get(
        "/profiles?itr=1&type=subscribtion&rows=1000000",
      );
      if (response.status == 200) this.profiles = response.data.data;
    },
    update_price() {
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.account.profile_id;
      });
      profile = profile[0];
      this.price = profile.price;
    },
    fix_date() {
      if (this.account.id) return;
      let profile = this.profiles.filter((profile) => {
        return profile.id == this.account.profile_id;
      });
      profile = profile[0];
      this.account.fixed_expiration = moment().add(
        profile.expiration_value,
        profile.expiration_unit,
      );
      this.account.fixed_expiration.hours(0);
      this.account.fixed_expiration.minutes(0);
    },
    async fetchCard(id) {
      const response = await axios.get(`/cards/${id}/card`);
      if (response.status == 200) {
        this.card = response.data.data;
        this.card.fixed_expiration = moment(this.card.expires_at).format(
          "YYYY-MM-DD HH:mm:ss",
        );
      }
    },
    changeProfile(profile_id) {
      this.account.profile_id = profile_id;
    },
    validate() {
      this.validated = true;
      this.errors.username = null;
      if (!this.card.username) {
        this.errors.username = this.$t("errors.accounts.username_empty");
        this.validated = false;
      }
      if (this.card.username.length < 3) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_2");
      }
      if (this.card.username.includes("*")) {
        this.validated = false;
        this.errors.username = this.$t("errors.accounts.username_symbol");
      }
      this.errors.password = null;
      if (!this.card.password) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_empty");
      }
      if (this.card.password.length < 3) {
        this.validated = false;
        this.errors.password = this.$t("errors.accounts.password_2");
      }
    },
  },
};
</script>
